import React from 'react'

/** Ícone colorido «Google News» (espelho do tema velociraptor). */
export function GoogleNewsGlyph({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden
    >
      <path
        d="M18.5004 15.21C18.5004 15.5163 18.2478 15.7672 17.9392 15.7672H6.06167C5.75304 15.7672 5.50049 15.5163 5.50049 15.21V3.55715C5.50049 3.25087 5.75304 3 6.06167 3H17.9395C18.2482 3 18.5007 3.25087 18.5007 3.55715L18.5004 15.21Z"
        fill="#0C9D58"
      />
      <path opacity="0.2" d="M18.5005 5.9953L14.0488 5.42236L18.5005 6.6166V5.9953Z" fill="#004D40" />
      <path
        opacity="0.2"
        d="M12.2149 3.60779L5.47363 6.6179L12.9242 3.90602V3.89863C12.7932 3.61787 12.4742 3.48689 12.2149 3.60779Z"
        fill="#004D40"
      />
      <path
        opacity="0.2"
        d="M17.9395 3H6.06167C5.75304 3 5.50049 3.25088 5.50049 3.55717V3.6821C5.50049 3.37581 5.75304 3.12493 6.06167 3.12493H17.9395C18.2482 3.12493 18.5007 3.37581 18.5007 3.6821V3.55717C18.5004 3.25088 18.2482 3 17.9395 3Z"
        fill="white"
      />
      <path
        d="M8.38302 14.8523C8.30275 15.1515 8.46295 15.4568 8.73901 15.5307L19.7404 18.4894C20.0164 18.5633 20.3079 18.3789 20.3878 18.0797L22.9795 8.40756C23.0598 8.10833 22.8996 7.80306 22.6235 7.72917L11.6222 4.77045C11.3461 4.69657 11.0546 4.88094 10.9747 5.18017L8.38302 14.8523Z"
        fill="#EA4335"
      />
      <path opacity="0.2" d="M20.5005 11.8601L21.0791 15.3753L20.5005 17.5357V11.8601Z" fill="#3E2723" />
      <path opacity="0.2" d="M14.1006 5.56653L14.619 5.7059L14.9406 7.87535L14.1006 5.56653Z" fill="#3E2723" />
      <path
        opacity="0.2"
        d="M22.6234 7.72917L11.6221 4.77045C11.346 4.69657 11.0545 4.88094 10.9746 5.18017L8.38291 14.8523C8.37854 14.8684 8.37753 14.8848 8.37451 14.901L10.9467 5.30208C11.027 5.00285 11.3185 4.81848 11.5942 4.89236L22.5955 7.85108C22.8565 7.92094 23.0113 8.198 22.9599 8.48111L22.9797 8.40756C23.0596 8.10833 22.8995 7.80306 22.6234 7.72917Z"
        fill="white"
      />
      <path
        d="M17.0474 13.6609C17.1532 13.952 17.0202 14.2701 16.7519 14.3678L5.14295 18.593C4.87428 18.6907 4.568 18.5325 4.46221 18.2413L1.03734 8.83186C0.931553 8.54069 1.06454 8.22265 1.33288 8.12492L12.9418 3.89976C13.2105 3.80203 13.5167 3.96021 13.6225 4.25138L17.0474 13.6609Z"
        fill="#FFC107"
      />
      <path
        opacity="0.2"
        d="M1.08103 8.95014C0.975239 8.65897 1.10823 8.34093 1.37657 8.2432L12.9856 4.0177C13.2513 3.92098 13.5532 4.07513 13.6624 4.36026L13.6224 4.25077C13.5163 3.9596 13.21 3.80142 12.9417 3.89915L1.33258 8.12465C1.0639 8.22238 0.930908 8.54042 1.03703 8.83159L4.46196 18.2411C4.46297 18.2441 4.46498 18.2468 4.46633 18.2501L1.08103 8.95014Z"
        fill="white"
      />
      <path
        d="M20.5006 20.4377C20.5006 20.747 20.2474 21.0002 19.938 21.0002H4.06302C3.75371 21.0002 3.50049 20.747 3.50049 20.4377V8.43789C3.50049 8.12859 3.75371 7.87537 4.06302 7.87537H19.938C20.2474 7.87537 20.5006 8.12859 20.5006 8.43789V20.4377Z"
        fill="#4285F4"
      />
      <path
        d="M17.4689 12.6256H12.7188V11.3754H17.4689C17.6069 11.3754 17.7188 11.4872 17.7188 11.6253V12.3753C17.7188 12.5134 17.6069 12.6256 17.4689 12.6256Z"
        fill="white"
      />
      <path
        d="M17.4689 17.3752H12.7188V16.1252H17.4689C17.6069 16.1252 17.7188 16.2371 17.7188 16.3751V17.125C17.7188 17.2634 17.6069 17.3752 17.4689 17.3752Z"
        fill="white"
      />
      <path
        d="M18.2188 14.9994H12.7188V13.7494H18.2188C18.3568 13.7494 18.4686 13.8612 18.4686 13.9993V14.7492C18.4686 14.8875 18.3568 14.9994 18.2188 14.9994Z"
        fill="white"
      />
      <path
        opacity="0.2"
        d="M19.938 20.8749H4.06302C3.75371 20.8749 3.50049 20.6217 3.50049 20.3124V20.4373C3.50049 20.7466 3.75371 20.9998 4.06302 20.9998H19.938C20.2474 20.9998 20.5006 20.7466 20.5006 20.4373V20.3124C20.5006 20.6217 20.2474 20.8749 19.938 20.8749Z"
        fill="#E7E7E9"
      />
      <path
        opacity="0.2"
        d="M4.06302 8.0003H19.938C20.2474 8.0003 20.5006 8.25352 20.5006 8.56282V8.43789C20.5006 8.12859 20.2474 7.87537 19.938 7.87537H4.06302C3.75371 7.87537 3.50049 8.12859 3.50049 8.43789V8.56282C3.50049 8.25352 3.75371 8.0003 4.06302 8.0003Z"
        fill="white"
      />
      <path
        d="M8.46863 13.8752V15.0026H10.0864C9.95269 15.6894 9.34886 16.1874 8.46863 16.1874C7.48664 16.1874 6.69037 15.3569 6.69037 14.3749C6.69037 13.393 7.48664 12.5625 8.46863 12.5625C8.91092 12.5625 9.30688 12.7146 9.61954 13.0125L10.4756 12.1572C9.95571 11.6726 9.27766 11.3754 8.46829 11.3754C6.81161 11.3754 5.46826 12.7183 5.46826 14.3753C5.46826 16.0322 6.81127 17.3752 8.46829 17.3752C10.2009 17.3752 11.3407 16.1572 11.3407 14.4435C11.3407 14.247 11.3226 14.0576 11.2934 13.8752H8.46863Z"
        fill="white"
      />
      <g opacity="0.2">
        <path d="M8.50061 15.0029V15.1279H10.0881C10.0999 15.0869 10.1099 15.0452 10.1183 15.0029H8.50061Z" fill="#E7E7E9" />
        <path
          d="M8.50057 17.3753C6.86468 17.3753 5.53541 16.0659 5.50217 14.4377C5.50183 14.4586 5.50049 14.4794 5.50049 14.5002C5.50049 16.1572 6.84352 17.5002 8.50057 17.5002C10.2332 17.5002 11.373 16.2822 11.373 14.5684C11.373 14.5546 11.3713 14.5419 11.3713 14.5281C11.3341 16.1972 10.2046 17.3753 8.50057 17.3753Z"
          fill="#E7E7E9"
        />
        <path
          d="M9.65158 13.0128C9.33891 12.7153 8.94263 12.5628 8.50067 12.5628C7.51868 12.5628 6.72241 13.3933 6.72241 14.3753C6.72241 14.3965 6.72476 14.4169 6.72543 14.4378C6.75868 13.4833 7.5395 12.6877 8.50067 12.6877C8.94296 12.6877 9.33891 12.8399 9.65158 13.1377L10.5701 12.2199C10.5486 12.1997 10.5248 12.1819 10.5026 12.1625L9.65158 13.0128Z"
          fill="#E7E7E9"
        />
      </g>
    </svg>
  )
}
